import { render, staticRenderFns } from "./ViAdmissionAcademicYear.vue?vue&type=template&id=70923279"
import script from "./ViAdmissionAcademicYear.vue?vue&type=script&lang=js"
export * from "./ViAdmissionAcademicYear.vue?vue&type=script&lang=js"
import style0 from "./ViAdmissionAcademicYear.vue?vue&type=style&index=0&id=70923279&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports